module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "end-title1-a"
  }, [_c('b', [_c('span', [_vm._v("PRAISE FOR THE WRITING OF ANDREW KAPLAN")])])]), _vm._v(" "), _c('p', {
    staticClass: "section-1a"
  }, [_c('span', [_c('i', [_vm._v("War of the Raven")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal-1"
  }, [_vm._v("“In a word, "), _c('i', [_vm._v("terrific")]), _vm._v(" … The pace is blistering, the atmosphere menacing and decadent, and author Andrew Kaplan is in marvelously smashing form.” —"), _c('i', [_vm._v("Daily News")]), _vm._v(" (New York)")]), _vm._v(" "), _c('p', {
    staticClass: "normal-1"
  }, [_vm._v("“The characters and locales are brilliantly etched … the plot riveting.” —"), _c('i', [_vm._v("The Times")]), _vm._v(" (London)")]), _vm._v(" "), _c('p', {
    staticClass: "normal-1"
  }, [_vm._v("“A smashing, sexy and unforgettable read.” —"), _c('i', [_vm._v("Publishers Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "section-1a"
  }, [_c('span', [_vm._v("Scorpion")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-1"
  }, [_vm._v("“Pure dynamite … espionage laced with high-voltage Middle East adventure.” —"), _c('i', [_vm._v("The Washington Times")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-1"
  }, [_vm._v("“A fast-paced, supercharged debut thriller.” —"), _c('i', [_vm._v("Kirkus Reviews")])]), _vm._v(" "), _c('p', {
    staticClass: "section-1a"
  }, [_c('span', [_vm._v("Dragonfire")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-1"
  }, [_vm._v("“A superb and original blending of Eastern mysticism with the shadowy world of espionage.” —Nelson DeMille, "), _c('i', [_vm._v("New York Times")]), _vm._v("-bestselling author of "), _c('i', [_vm._v("Word of Honor")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-1"
  }, [_vm._v("“Electrifying … A searing, ultimately satisfying entertainment with energy, passion, and moral resonance.” —"), _c('i', [_vm._v("Kirkus Reviews")])]), _vm._v(" "), _c('p', {
    staticClass: "section-1a"
  }, [_c('span', [_vm._v("Hour of the Assassins")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-1"
  }, [_vm._v("“An exciting, original suspense novel.” —"), _c('i', [_vm._v("Buffalo Evening News")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-598e2671","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/endmatter03.vue
// module id = 60
// module chunks = 0